'use strict';
var validator = require('validator');

var paginationMove = document.querySelectorAll('.news-list-pagination--move');
var pagination = document.getElementsByClassName('news-list-pagination')[0];
const form = document.querySelector('.contact-form-section__form');
const formEmail = document.querySelector("input[type='email']");

$(function () {
  var _window = $(window),
    _header = $('.creative-header__logo'),
    heroBottom;

  _window.on('scroll', function () {
    heroBottom = $('.creative-main-visual').height();

    if (_window.scrollTop() > heroBottom) {
      _header.addClass('fixed');
    } else {
      _header.removeClass('fixed');
    }
  });

  _window.trigger('scroll');

  $('input[type="checkbox"]').click(function () {
    if ($(this).prop('checked') === true) {
      $('.sp-nav__button').addClass('nav_fix');
    } else {
      $('.sp-nav__button').removeClass('nav_fix');
    }
  });

  $(document).ready(function () {
    setTimeout(function () {
      $('.home header').delay(1000).fadeIn(500);
      $('.home footer').delay(1000).fadeIn(500);
      $('.home .contact-section').delay(1000).fadeIn(500);
      $('.ksb-site-content').delay(1000).fadeIn(500);
      $('.ksb-loading-bg').addClass('slide-out');
      $('.ksb-loading-bg').delay(0).fadeOut(800);
      $('.ksb-loading').delay(800).fadeOut(300);
    }, 2000);
  });

  //10秒たったら強制的にロード画面を非表示
  $(function () {
    setTimeout(stopload, 10000);
  });

  function stopload() {
    $('.ksb-site-content').delay(1000).fadeIn(500);
    $('.ksb-loading-bg').addClass('slide-out');
    $('.ksb-loading-bg').delay(0).fadeOut(800);
    $('.ksb-loading').delay(800).fadeOut(300);
  }
});

paginationMove.forEach(function (item) {
  item.addEventListener('mouseover', function (event) {
    pagination.style.color = 'rgba(39, 61, 124, 0.8)';
  });

  item.addEventListener('mouseleave', function (event) {
    pagination.style.color = '#273D7C';
  });
});

$(function () {
  var _window = $(window),
    _header = $('.creative-header__logo'),
    heroBottom;

  _window.on('scroll', function () {
    heroBottom = $('.creative-main-visual').height();

    if (_window.scrollTop() > heroBottom) {
      _header.addClass('fixed');
    } else {
      _header.removeClass('fixed');
    }
  });

  _window.trigger('scroll');

  $('input[type="checkbox"]').click(function () {
    if ($(this).prop('checked') === true) {
      $('.sp-nav__button').addClass('nav_fix');
    } else {
      $('.sp-nav__button').removeClass('nav_fix');
    }
  });
});

// フォームバリデーション
if (form) {
  function formValidation() {
    const requiredElements = document.querySelectorAll(
      'input:required, textarea:required',
    );

    const validationObj = {
      0: false,
      1: false,
      2: false,
      3: false,
      4: false,
    };

    // blurしたとき、オブジェクトの結果を更新する
    requiredElements.forEach(function (elm, index) {
      elm.addEventListener('blur', function () {
        const elementSibling = elm.nextElementSibling;

        if (elm.value === '') {
          validationObj[index] = false;
          elementSibling.textContent = '※入力をしてください';
        } else {
          validationObj[index] = true;
          elementSibling.textContent = '';
        }
      });
    });

    // メールアドレスが正しいかチェック
    formEmail.addEventListener('blur', function () {
      const elementSibling = formEmail.nextElementSibling;
      const emailValue = formEmail.value;

      if (emailValue) {
        if (!validator.isEmail(emailValue)) {
          validationObj[3] = false;
          elementSibling.textContent =
            '※正しいメールアドレスを入力してください';
        } else {
          validationObj[3] = true;
          elementSibling.textContent = '';
        }
      }
    });

    // submitしたときは、配列の結果チェックのみ行う
    form.addEventListener('submit', function (event) {
      const validationArray = Object.values(validationObj);

      if (validationArray.includes(false)) {
        event.preventDefault();

        requiredElements.forEach(function (elm, index) {
          const elmSibling = elm.nextElementSibling;

          if (elm.value === '') {
            elmSibling.textContent = '※入力をしてください';

            form.scrollIntoView({
              behavior: 'smooth',
            });
          }
        });
      }
    });
  }

  formValidation();
}
